import { ConcreteMixDesigns } from '../../../cimsPage/instances/materials'
import { Simple } from '../../common'

const object = 'Concrete Mix Design'
const page = ConcreteMixDesigns

export const CreateConcreteMixDesign = Simple({
  id: 'b7de6227-a866-4352-af9e-f23608b8ba92',
  action: 'Create',
  object,
  page,
})

export const EditConcreteMixDesign = Simple({
  id: '2cae03e9-cabd-491a-a67a-4eba149ecbb7',
  action: 'Edit',
  object,
  page,
})

export const ViewConcreteMixDesign = Simple({
  id: '2d5c8425-bf44-489a-ae21-29ee3c27e6fb',
  action: 'View',
  object,
  page,
})

export type ConcreteMixDesignPermissionItem =
  | typeof CreateConcreteMixDesign
  | typeof EditConcreteMixDesign
  | typeof ViewConcreteMixDesign
